import { PermissionsService } from '@services/auth/permissions.service';
import { Permission } from '@services/auth/authorization';
import { PermissionAccessLevel } from '@services/auth/authorization';
import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[appDisableIfUnauthorized]'
})
export class DisableIfUnauthorizedDirective implements OnInit {
  @Input() section: Permission;
  @Input() allowedActions: PermissionAccessLevel[];

  constructor(private el: ElementRef, private renderer: Renderer2, private permissions: PermissionsService) {}

  ngOnInit() {
    if (!this.allowedActions.includes(this.permissions.getPermission(this.section))) {
      this.renderer.setProperty(this.el.nativeElement, 'disabled', 'true');
    }
  }
}
